import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { getStartDateForSchoolYear } from '../../../../../../../helpers/calendar/calendar';
import { ReportActions, ReportCheckboxGrid, ReportDateRange, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Clubs.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; activeSchoolId: string; }

const getAcademicYear = (date: Date) => date.getMonth() >= 8 ? date.getFullYear() : date.getFullYear() - 1;

// report 003
export const ParticipationsByClubsReportForm = ({ onCloseClick, onSubmit, activeSchoolId }: Props) => {
  const [schoolData, setSchoolData] = React.useState<any>(null);
  React.useEffect(() => {
    fetch('/dist/images/mis/misIntegrationSchoolsList.json').then(response => response.json()).then(data => setSchoolData(data.find(item => item.schoolSITId === activeSchoolId))).catch(error => console.error('Error loading JSON:', error));
  }, [activeSchoolId]);

  const initialValues = { dateFrom: getStartDateForSchoolYear(new Date()), dateTo: new Date(), include: 'participants', isPrintPP: false, isPrintSEN: false, isPrintFSM: false, isPrintEthnicity: false };
  return <Formik enableReinitialize initialValues={{ ...initialValues,
    isPrintPP: schoolData ? schoolData.studentsPPInfo === 1 : false,
    isPrintSEN: schoolData ? schoolData.studentsSENInfo === 1 : false,
    isPrintFSM: schoolData ? schoolData.studentsFSMInfo === 1 : false,
    isPrintEthnicity: schoolData ? schoolData.studentsEthnicityCode === 1 : false
  }} onSubmit={values => {
    const data: any = { ...values, isShowZero: values.include === 'zero', isShowNonZero: values.include === 'participants' };
    delete data.include;
    onSubmit(data, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PARTICIPATION_STATISTICS_BY_CLUBS);
  }}>
    {({ values, setFieldValue }) => {
      const includesHistoricalPeriod = getAcademicYear(values.dateFrom) !== getAcademicYear(new Date());
      const includesCurrentProfileData = values.isPrintPP || values.isPrintSEN || values.isPrintFSM || values.isPrintEthnicity;
      const status = includesHistoricalPeriod && includesCurrentProfileData
        ? 'Student breakdowns use the values currently recorded on each student profile.'
        : 'Ready to generate';
      return <Form className="eReportForm">
      <div className="eReportForm__scroll">
          <ReportDescription>One row per club, showing students listed in at least one club session, club capacity and optional gender and student-characteristic breakdowns.</ReportDescription>
        <ReportSection number={1} title="Reporting period" hint="Choose the date range covered by the report." required>
          <ReportDateRange dateFrom={values.dateFrom} dateTo={values.dateTo} onChangeFrom={date => { setFieldValue('dateFrom', date); if (values.dateTo < date) setFieldValue('dateTo', date); }} onChangeTo={date => setFieldValue('dateTo', date)} />
        </ReportSection>
        <ReportSection number={2} title="Include" hint="Choose which clubs should appear in the report.">
          <ReportCheckboxGrid
            items={[
              { name: 'Clubs with participants', isChecked: values.include === 'participants' },
              { name: 'Clubs with no participants', isChecked: values.include === 'zero' }
            ]}
            onChange={index => setFieldValue('include', index === 0 ? 'participants' : 'zero')}
          />
        </ReportSection>
        <ReportSection number={3} title="Student information" hint="Choose additional information and breakdowns to include."><ReportToggleList>
          <ReportToggle name="isPrintPP" label="Show PP" hint="Include pupil premium information." value={values.isPrintPP} onChange={value => setFieldValue('isPrintPP', value)} />
          <ReportToggle name="isPrintSEN" label="Show SEN" hint="Include SEN information." value={values.isPrintSEN} onChange={value => setFieldValue('isPrintSEN', value)} />
          <ReportToggle name="isPrintFSM" label="Show FSM" hint="Include free school meals information." value={values.isPrintFSM} onChange={value => setFieldValue('isPrintFSM', value)} />
          <ReportToggle name="isPrintEthnicity" label="Break down by ethnicity" hint="Include ethnicity code breakdowns." value={values.isPrintEthnicity} onChange={value => setFieldValue('isPrintEthnicity', value)} />
        </ReportToggleList></ReportSection>
      </div>
      <ReportActions onCancel={onCloseClick} status={status} />
    </Form>}}
  </Formik>;
};
